/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as UserProfileImport } from './routes/user-profile'
import { Route as RankingImport } from './routes/ranking'
import { Route as NotFoundImport } from './routes/not-found'
import { Route as MaintainImport } from './routes/maintain'
import { Route as EditProfileImport } from './routes/edit-profile'
import { Route as DashboardImport } from './routes/dashboard'
import { Route as IndexImport } from './routes/index'

// Create/Update Routes

const UserProfileRoute = UserProfileImport.update({
  id: '/user-profile',
  path: '/user-profile',
  getParentRoute: () => rootRoute,
} as any)

const RankingRoute = RankingImport.update({
  id: '/ranking',
  path: '/ranking',
  getParentRoute: () => rootRoute,
} as any)

const NotFoundRoute = NotFoundImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRoute,
} as any)

const MaintainRoute = MaintainImport.update({
  id: '/maintain',
  path: '/maintain',
  getParentRoute: () => rootRoute,
} as any)

const EditProfileRoute = EditProfileImport.update({
  id: '/edit-profile',
  path: '/edit-profile',
  getParentRoute: () => rootRoute,
} as any)

const DashboardRoute = DashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardImport
      parentRoute: typeof rootRoute
    }
    '/edit-profile': {
      id: '/edit-profile'
      path: '/edit-profile'
      fullPath: '/edit-profile'
      preLoaderRoute: typeof EditProfileImport
      parentRoute: typeof rootRoute
    }
    '/maintain': {
      id: '/maintain'
      path: '/maintain'
      fullPath: '/maintain'
      preLoaderRoute: typeof MaintainImport
      parentRoute: typeof rootRoute
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundImport
      parentRoute: typeof rootRoute
    }
    '/ranking': {
      id: '/ranking'
      path: '/ranking'
      fullPath: '/ranking'
      preLoaderRoute: typeof RankingImport
      parentRoute: typeof rootRoute
    }
    '/user-profile': {
      id: '/user-profile'
      path: '/user-profile'
      fullPath: '/user-profile'
      preLoaderRoute: typeof UserProfileImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/edit-profile': typeof EditProfileRoute
  '/maintain': typeof MaintainRoute
  '/not-found': typeof NotFoundRoute
  '/ranking': typeof RankingRoute
  '/user-profile': typeof UserProfileRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/edit-profile': typeof EditProfileRoute
  '/maintain': typeof MaintainRoute
  '/not-found': typeof NotFoundRoute
  '/ranking': typeof RankingRoute
  '/user-profile': typeof UserProfileRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/edit-profile': typeof EditProfileRoute
  '/maintain': typeof MaintainRoute
  '/not-found': typeof NotFoundRoute
  '/ranking': typeof RankingRoute
  '/user-profile': typeof UserProfileRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/edit-profile'
    | '/maintain'
    | '/not-found'
    | '/ranking'
    | '/user-profile'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/edit-profile'
    | '/maintain'
    | '/not-found'
    | '/ranking'
    | '/user-profile'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/edit-profile'
    | '/maintain'
    | '/not-found'
    | '/ranking'
    | '/user-profile'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRoute
  EditProfileRoute: typeof EditProfileRoute
  MaintainRoute: typeof MaintainRoute
  NotFoundRoute: typeof NotFoundRoute
  RankingRoute: typeof RankingRoute
  UserProfileRoute: typeof UserProfileRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRoute,
  EditProfileRoute: EditProfileRoute,
  MaintainRoute: MaintainRoute,
  NotFoundRoute: NotFoundRoute,
  RankingRoute: RankingRoute,
  UserProfileRoute: UserProfileRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/dashboard",
        "/edit-profile",
        "/maintain",
        "/not-found",
        "/ranking",
        "/user-profile"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/dashboard": {
      "filePath": "dashboard.tsx"
    },
    "/edit-profile": {
      "filePath": "edit-profile.tsx"
    },
    "/maintain": {
      "filePath": "maintain.tsx"
    },
    "/not-found": {
      "filePath": "not-found.tsx"
    },
    "/ranking": {
      "filePath": "ranking.tsx"
    },
    "/user-profile": {
      "filePath": "user-profile.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
